import React, { useMemo } from 'react'
import { createUseStyles } from 'react-jss'
import { useSelector } from 'react-redux'
import { getProducts } from '../../redux/slices/content/selectors'
import RelatedProductCard from '../RelatedProductCard'
import Slider from '../Slider'
import { resolveLink } from '../../helpers/resolveLink'
import get from 'lodash/get'
import theme from '../../style/theme'
import { span } from '../../style/span'
import { vw } from '../../style/vw'

const ProductBuySlider = ({ slice, className }) => {
  const classes = useStyles()
  const { link } = slice
  const allProducts = useSelector(getProducts)

  const products = useMemo(() => {
    const productReferences = slice?.products || []
    if (!productReferences.length) {
      return allProducts || []
    }
    const configuredProductIds = productReferences.map(ref => ref._id || ref._ref || ref.id)
    const filteredProducts = (allProducts || []).filter(product => {
      const productId = product._id || product.id
      return configuredProductIds.includes(productId)
    })
    return filteredProducts
  }, [allProducts, slice])

  if (!products || products.length === 0) return null

  return (
    <Slider className={classes.slider} link={resolveLink(get(link, [0]))} title={slice?.title} description={slice?.description}>
      {products.map(product => (
        <div key={product._id || product.id} className={classes.sliderItem}>
          <RelatedProductCard product={product} />
        </div>
      ))}
    </Slider>
  )
}
const useStyles = createUseStyles({
  container: {
    maxWidth: 'calc(100% - 9rem)',
    margin: '0 auto',
    paddingTop: span(2),
    paddingBottom: span(1),
    height: 'fit-content',
    paddingLeft: '0',
    paddingRight: '0',
    overflowY: 'hidden',
    '@media (max-width: 1500px)': {
      maxWidth: 'calc(100% - 7rem)'
    },
    '@media (max-width: 1024px)': {
      maxWidth: 'calc(100% - 7rem)'
    },
    '@media (max-width: 600px)': {
      maxWidth: 'calc(100% - 3.5rem)'
    }
  },
  slider: {
    paddingBottom: '2rem'
  },
  sliderItem: {
    flex: '0 0 auto',
    scrollSnapAlign: 'start',
    marginRight: '20px',
    width: vw(290),
    '&:last-child': {
      marginRight: '0'
    },
    [theme.breakpoints.up('md')]: {
      width: span(7.85, 'md'),
      margin: [0, span(0.18, 'md'), 0, span(0.18, 'md')] // Adjust margin for better spacing
    }
  }
}, { name: 'ProductBuySlider' })

export default ProductBuySlider
